import Preact, { Component } from 'preact';
import Cookies from 'js-cookie';
import base64 from 'base-64';
import { ManagePreferenceModal } from './ManagePreferenceModal/ManagePreferenceModal';
import { CookieBannerPopup } from './CookieBannerPopup/CookieBannerPopup';
import cookie from 'cookie';
import makeAPIRequest from '@jg/http-client';
import { clientConfig } from '../../config';
import { Experiments, Variants } from '../../constants/experiments';

interface Props {}
declare global {
  interface Window {
    CookieConsent: any;
  }
}

export const COOKIE_NAMES = {
  GGASPXAUTH_BEARER: '.GGASPXAUTH_BEARER',
};

interface State {
  isBannerOpen: boolean;
  isManagePrefOpen: boolean;
  hasResponse: boolean;
  enrolledPrimaryVariant: Variants;
  enrolledSecondaryVariant: Variants;
}

export class CookieBanner extends Component<Props> {
  state: State = {
    isManagePrefOpen: false,
    isBannerOpen: true,
    hasResponse: false,
    enrolledPrimaryVariant: Variants.N,
    enrolledSecondaryVariant: Variants.N,
  };

  multiValueCookieParser = Cookies.withConverter({
    read: value => {
      const cookieValues: any = {};
      value.split('&').forEach((part: any) => {
        const keyVal = part.split('=');
        cookieValues[keyVal[0]] = keyVal[1];
      });
      return cookieValues;
    },
  });

  componentDidMount() {
    // Task: 1982872 - Enrol user to ABC test for cookiebot banner. REMOVE IT ONCE RESULT COMPLETE.
    this.enrolUserToAbTest(Experiments.cookie_banner_optin_rate_jing);
    this.enrolUserToAbTest(Experiments.cookie_banner_optin_rate);
    window.addEventListener('loadCookieBot', this.showModal);
    window.addEventListener('cookiebotMoreOptions', this.showManagePreference);
    window.addEventListener('cookiebotAcceptBlueBanner', () =>
      this.markSuccessForAbTest(
        Experiments.cookie_banner_optin_rate_jing,
        'CookiebotBlueBannerAcceptedAll',
      ),
    );
    let hasCookieResponse = cookie.parse(document.cookie)['CookieConsent']
      ? true
      : false;
    this.setState({
      isManagePrefOpen: false,
      isBannerOpen: true,
      hasResponse: hasCookieResponse,
    });
  }
  showModal = () => {
    this.setState({
      isManagePrefOpen: false,
      isBannerOpen: true,
      hasResponse: false,
    });
  };

  showManagePreference = () => {
    this.setState({
      isManagePrefOpen: true,
      isBannerOpen: false,
      hasResponse: false,
    });
  };

  setBannerAndManagePrefPopup = (
    isManagePrefValue: any,
    isBannerOpenValue: any,
  ) => {
    this.setState({
      isManagePrefOpen: isManagePrefValue,
      isBannerOpen: isBannerOpenValue,
    });
  };
  setHasResponse = (hasResponseValue: any) => {
    this.setState({
      isManagePrefOpen: this.state.isManagePrefOpen,
      isBannerOpen: this.state.isBannerOpen,
      hasResponse: hasResponseValue,
    });
  };
  render() {
    const primaryVariant = this.state.enrolledPrimaryVariant;
    const secondaryVariant = this.state.enrolledSecondaryVariant;
    return (
      <div>
        {primaryVariant != Variants.A &&
          primaryVariant != Variants.N &&
          !this.state.hasResponse &&
          this.state.isBannerOpen && (
            <CookieBannerPopup
              openManagePref={false}
              handleManagePref={this.setBannerAndManagePrefPopup}
              setHasResponse={this.setHasResponse}
              variant={primaryVariant}
              markSuccess={() =>
                this.markSuccessForAbTest(
                  Experiments.cookie_banner_optin_rate_jing,
                  'CookiebotPopupAcceptedAll',
                )
              }
            />
          )}
        {this.state.isManagePrefOpen && (
          <ManagePreferenceModal
            openManagePref={this.state.isManagePrefOpen}
            handleManagePref={this.setBannerAndManagePrefPopup}
            setHasResponse={this.setHasResponse}
            markSuccess={(
              sucessType: string,
              p: boolean,
              s: boolean,
              m: boolean,
            ) => {
              if (sucessType == 'CookiebotSecondaryPopupAcceptedAll') {
                this.markSuccessForAbTest(
                  Experiments.cookie_banner_optin_rate,
                  sucessType,
                );
              } else {
                this.saveChangesMarkSuccess(p, s, m);
              }
            }}
            variant={secondaryVariant}
          />
        )}
      </div>
    );
  }

  private saveChangesMarkSuccess(p: boolean, s: boolean, m: boolean) {
    let abSuccess = '';
    if (p) {
      abSuccess = abSuccess.concat('-P');
    }
    if (s) {
      abSuccess = abSuccess.concat('-S');
    }
    if (m) {
      abSuccess = abSuccess.concat('-M');
    }
    this.markSuccessForAbTest(
      Experiments.cookie_banner_optin_rate,
      `CookiebotPopupSaveChanges-N${abSuccess}`,
    );
  }

  async enrolUserToAbTest(slug: string) {
    const { jgAnalyticsCookieName, abApiUrl } = clientConfig;
    let guids = cookie.parse(document.cookie)[jgAnalyticsCookieName];
    if (!guids) {
      // create JGAnalytics cookie if not exists
      this.setIdentityGuids({});
      guids = cookie.parse(document.cookie)[jgAnalyticsCookieName];
    }

    if (guids) {
      const response = await makeAPIRequest(
        `${abApiUrl}/api/abtests/${slug}/enrol`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            cookie: `${jgAnalyticsCookieName}=${guids}`,
          },
        },
      );
      await this.OpenBanner(slug, response);
    } else {
      this.setDefaultState(slug);
    }
  }

  private async OpenBanner(slug: string, response: Response) {
    if (response.ok) {
      const result = await response.json();
      const enrolled = result && result.enrolledIn;
      if (slug == Experiments.cookie_banner_optin_rate_jing) {
        this.setState({ enrolledPrimaryVariant: enrolled });
        var cookiebotBlueBanner = window.document.getElementById(
          'CybotCookiebotDialogv2',
        );
        if (!this.state.hasResponse && cookiebotBlueBanner)
          cookiebotBlueBanner.style.display =
            enrolled == Variants.A ? 'block' : 'none';
      } else if (slug == Experiments.cookie_banner_optin_rate) {
        this.setState({ enrolledSecondaryVariant: enrolled });
      }
    }
  }

  async markSuccessForAbTest(slug: string, typeName: string) {
    const { jgAnalyticsCookieName, abApiUrl } = clientConfig;
    const guids = cookie.parse(document.cookie)[jgAnalyticsCookieName];
    if (guids) {
      await makeAPIRequest(`${abApiUrl}/api/abtests/${slug}/markSuccessful`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          cookie: `${jgAnalyticsCookieName}=${guids}`,
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          successType: typeName,
        }),
      });
    }
  }

  setIdentityGuids(eventData: any) {
    const loggedInGuid = this.getLoggedInGuid();
    const loggedOutGuid = this.getLoggedOutGuid();
    const { jgAnalyticsCookieName } = clientConfig;
    this.setValueOrEmptyString('logged_in_guid', loggedInGuid, eventData);
    this.setValueOrEmptyString('logged_out_guid', loggedOutGuid, eventData);
    const analyticsCookieValue = this.createJGAnalyticsCookieString(
      this.getAnalyticsCookie(),
      loggedOutGuid,
      loggedInGuid,
    );
    this.setCookie(jgAnalyticsCookieName, analyticsCookieValue);
  }

  setCookie(name: any, value: any) {
    Cookies.set(name, value, { expires: 3650, domain: '.justgiving.com' });
  }

  getLoggedInGuid() {
    const bearerToken: any = this.getAuthBearerCookie().access_token;
    if (bearerToken) {
      const jwt = this.parseJwt(bearerToken);
      return jwt.sub;
    }
    return this.getAnalyticsCookie().logged_in_guid;
  }

  getLoggedOutGuid() {
    let loggedOutGuid = this.getAnalyticsCookie().logged_out_guid;
    if (
      !loggedOutGuid ||
      loggedOutGuid === '00000000-0000-0000-0000-000000000000'
    ) {
      loggedOutGuid = this.generateGUID();
    }
    return loggedOutGuid;
  }

  getAuthBearerCookie() {
    let cookie: any = this.multiValueCookieParser.get(
      COOKIE_NAMES.GGASPXAUTH_BEARER,
    );
    cookie = cookie || {};
    return cookie;
  }

  parseJwt(token: any) {
    const base64Url = token.split('.')[1];
    const base64Clean = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(base64.decode(base64Clean));
  }

  createJGAnalyticsCookieString(
    jgAnalyticsProperties: any,
    loggedOutValue: any,
    loggedInValue: any,
  ) {
    const analyticsCookie = jgAnalyticsProperties;
    analyticsCookie.logged_in_guid =
      loggedInValue || '00000000-0000-0000-0000-000000000000';
    analyticsCookie.logged_out_guid =
      loggedOutValue || '00000000-0000-0000-0000-000000000000';

    const stringValues = Object.keys(analyticsCookie).map(
      key => `${key}=${analyticsCookie[key]}`,
    );
    return stringValues.join('&');
  }

  getAnalyticsCookie(): any {
    const { jgAnalyticsCookieName } = clientConfig;

    const cookie = this.multiValueCookieParser.get(jgAnalyticsCookieName);
    return cookie || {};
  }

  generateGUID() {
    const lut = [];
    for (let i = 0; i < 256; i++) {
      lut[i] = (i < 16 ? '0' : '') + i.toString(16);
    }

    const d0 = (Math.random() * 0xffffffff) | 0;
    const d1 = (Math.random() * 0xffffffff) | 0;
    const d2 = (Math.random() * 0xffffffff) | 0;
    const d3 = (Math.random() * 0xffffffff) | 0;
    return `${lut[d0 & 0xff] +
      lut[(d0 >> 8) & 0xff] +
      lut[(d0 >> 16) & 0xff] +
      lut[(d0 >> 24) & 0xff]}-${lut[d1 & 0xff]}${lut[(d1 >> 8) & 0xff]}-${
      lut[((d1 >> 16) & 0x0f) | 0x40]
    }${lut[(d1 >> 24) & 0xff]}-${lut[(d2 & 0x3f) | 0x80]}${
      lut[(d2 >> 8) & 0xff]
    }-${lut[(d2 >> 16) & 0xff]}${lut[(d2 >> 24) & 0xff]}${lut[d3 & 0xff]}${
      lut[(d3 >> 8) & 0xff]
    }${lut[(d3 >> 16) & 0xff]}${lut[(d3 >> 24) & 0xff]}`;
  }

  setValueOrEmptyString(propertyName: any, value: any, object: any) {
    if (value != null && value.length !== 0 && propertyName) {
      object[propertyName] = value;
    }
  }

  setDefaultState(slug: string) {
    if (slug == Experiments.cookie_banner_optin_rate)
      this.setState({ enrolledSecondaryVariant: Variants.B });
    else this.setState({ enrolledPrimaryVariant: Variants.B });
  }
}

export default CookieBanner;
